import {
  Box,
  Card,
  List,
  ListItem,
  makeStyles,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
  withStyles,
  Fade,
  useTheme,
  useMediaQuery 
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Pagination } from '@material-ui/lab';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import DialogConfirm from 'src/app/components/DialogConfirm';
import { MESSAGE } from 'src/app/constant/message';
import { closeDialogConfirm, showDialogConfirm } from 'src/features/uiSlice';
import { deleteMultiVehicleType } from 'src/features/vehicleTypeSlice';

import { useDispatch } from 'react-redux';
import LoadingComponent from 'src/app/components/Loading';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import EditVehicleType from './EditVehicleType';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  },
  body: {
    fontSize: 14,
    whiteSpace: 'nowrap'
  },
  root: {
    padding: '4px'
  }
}))(TableCell);

const Results = ({
  className,
  listVehicleTypes,
  getListVehicleTypesWithParams,
  params,
  setParams,
  ...rest
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const isLoading = useSelector(state => state.vehicleTypeSlice.isLoading);
  const total = useSelector(state => state.vehicleTypeSlice.total);
  const classes = useStyles();
  const [limit, setLimit] = useState(PAGE_SIZE_LIST);
  const [selectedItem, setSelectedItem] = useState();
  const [itemCurrent, setItemCurrent] = useState();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [rowsSelected, setRowsSelected] = useState([]);
  const [page, setPage] = useState(1);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClickMenu = (event, vehicleType) => {
    setAnchorEl(event.currentTarget);
    setItemCurrent({
      id: vehicleType.id,
      title: vehicleType.title,
      slots: vehicleType.slots,
      tonnage: vehicleType.tonnage
    });
    setSelectedItem(vehicleType.id);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const handleEditVehicleType = () => {
    setOpenEditModal(true);
    handleCloseMenu();
  };

  const handleDeleteVehicleType = () => {
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleDeleteMultiDeviceType = () => {
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const confirmDelete = () => {
    const listId = rowsSelected?.length > 0 ? rowsSelected : [selectedItem];
    setRowsSelected([]);
    dispatch(closeDialogConfirm());
    dispatch(deleteMultiVehicleType({ list_vehicle_type_id: listId }));
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListVehicleTypesWithParams) return;
    const newparams = Object.assign({}, params, { page: newPage });
    setParams(newparams);
    getListVehicleTypesWithParams(newparams);
  };

  const closeModal = () => {
    setOpenEditModal(false);
  };

  const checked = id => {
    return rowsSelected.indexOf(id) !== -1;
  };
  const select = driver => {
    if (rowsSelected.indexOf(driver) === -1) {
      const newSelected = [driver, ...rowsSelected];
      setRowsSelected(newSelected);
    } else {
      const newSelected = rowsSelected.filter(i => i !== driver);
      setRowsSelected(newSelected);
    }
  };

  const checkAll = () => {
    if (rowsSelected.length > 0) {
      setRowsSelected([]);
    }

    if (
      listVehicleTypes.length > 0 &&
      rowsSelected.length !== listVehicleTypes.length
    ) {
      const all = listVehicleTypes.map(item => {
        return item.id;
      });
      setRowsSelected(all);
    }
  };

  return (
    <>
      {openEditModal && (
        <EditVehicleType
          open={openEditModal}
          onClose={closeModal}
          vehicleType={itemCurrent}
        />
      )}

      <DialogConfirm
        title={MESSAGE.CONFIRM_DELETE_VEHICLETYPE}
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={MESSAGE.CONTENT_DELETE_VEHICLETYPE}
        callbackOk={() => confirmDelete()}
        callbackCancel={() => dispatch(closeDialogConfirm())}
      />

      <Card className={clsx(classes.root, className)} {...rest}>
        {isLoading ? (
          <LoadingComponent />
        ) : (
          <div>
            {rowsSelected.length > 0 && (
              <Fade in={rowsSelected.length > 0}>
                <Box
                  minWidth={1050}
                  style={{ fontSize: '14px', padding: '6px 4px' }}
                >
                  <span>
                    <Checkbox
                      checked={rowsSelected.length > 0}
                      onChange={() => checkAll()}
                      color="primary"
                      inputProps={{ 'aria-label': 'secondary checkbox' }}
                    />
                  </span>

                  <span
                    onClick={handleDeleteMultiDeviceType}
                    className="mx-2 btnDevice"
                    color="primary"
                    variant="outlined"
                    size="small"
                  >
                    <img
                      src={`/static/iconSvg/delete-icon.svg`}
                      alt="delete"
                      style={{ paddingRight: '5px', paddingBottom: '4px' }}
                    />
                    <span className="pt-1"> Xóa </span>
                  </span>
                </Box>
              </Fade>
            )}
            <PerfectScrollbar>
              {listVehicleTypes && listVehicleTypes.length ? (
                <Box minWidth={1050}>
                  <Table>
                    {rowsSelected.length === 0 && listVehicleTypes?.length > 0 && (
                      <TableHead>
                        <TableRow>
                          <StyledTableCell width={50}>
                            <Checkbox
                              checked={rowsSelected.length > 0}
                              onChange={() => checkAll()}
                              color="primary"
                              inputProps={{
                                'aria-label': 'secondary checkbox'
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell>Loại phương tiện </StyledTableCell>
                          <StyledTableCell>Số chỗ</StyledTableCell>
                          <StyledTableCell>Tải trọng</StyledTableCell>

                          <StyledTableCell></StyledTableCell>
                        </TableRow>
                      </TableHead>
                    )}
                    <TableBody>
                      {(listVehicleTypes || []).map((vehicleType, index) => (
                        <TableRow hover key={vehicleType.id}>
                          <StyledTableCell
                            style={{ maxWidth: '12px' }}
                            onClick={() => select(vehicleType?.id)}
                          >
                            <Checkbox
                              checked={checked(vehicleType.id)}
                              onChange={() => select(vehicleType.id)}
                              color="primary"
                              inputProps={{
                                'aria-label': 'secondary checkbox'
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            {vehicleType?.title || '-'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {vehicleType?.slots || '-'} chỗ{' '}
                          </StyledTableCell>
                          <StyledTableCell>
                            {vehicleType?.tonnage || '-'} tấn{' '}
                          </StyledTableCell>
                          <StyledTableCell>
                            <span style={{ color: '#AEB1C5' }}>
                              <MoreVertIcon
                                aria-describedby={`menu-device-${vehicleType.id}`}
                                className={`cursor-pointer hover-red`}
                                onClick={e => handleClickMenu(e, vehicleType)}
                              />
                            </span>

                            <Popover
                              id={`menu-device-${vehicleType.id}`}
                              className="popover-device"
                              open={open}
                              anchorEl={anchorEl}
                              onClose={handleCloseMenu}
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left'
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                              }}
                            >
                              <Typography>
                                <List>
                                  <ListItem
                                    onClick={handleEditVehicleType}
                                    className="border-bottom list-menu-device cursor-pointer"
                                  >
                                    Chỉnh sửa
                                  </ListItem>
                                  <ListItem
                                    onClick={handleDeleteVehicleType}
                                    className="cursor-pointer list-menu-device"
                                  >
                                    <span class="text-danger"> Xóa </span>
                                  </ListItem>
                                </List>
                              </Typography>
                            </Popover>
                          </StyledTableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              ) : (
                <div className="text-center pb-5">
                  <img src="/static/empty.png" class="justify-content-center" />
                  <h4> Danh sách trống </h4>
                </div>
              )}
            </PerfectScrollbar>
          </div>
        )}
      </Card>
      {listVehicleTypes && listVehicleTypes.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>Tổng: {total}</Typography>
            <Pagination
              count={Math.ceil(total / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page) || 1}
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 1 : 2}
              showFirstButton={!isMobile}
              showLastButton={!isMobile}
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listUser: PropTypes.array.isRequired
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default Results;
